module.exports = __webpack_public_path__ + "static/media/24n.147eb51e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/24n.svg
// module id = 165
// module chunks = 0